<template>
  <BasicLayout :left='left' :middle='middle' :right='right'>
    <template v-slot:left_view>
      <NeList ref='neList' :neArr='netype' :select='neClick'></NeList>
    </template>
    <template v-slot:right_view>
      <DNNProfileTableMenu @methodEnum='methodEnum'></DNNProfileTableMenu>
      <DNNProfileTable ref="dnnProfileTable"></DNNProfileTable>
    </template>
  </BasicLayout>
</template>

<script>
import DNNProfileTable from '../../../../components/subscriberconfig/udmSubscriber/dnn/DNNProfileTable';
import DNNProfileTableMenu from '../../../../components/subscriberconfig/udmSubscriber/dnn/DNNProfileTableMenu';
import BasicLayout from '../../../../layouts/BasicLayout';
import NeList from '../../../../components/common/NeList';

export default {
  name: 'DNNMainPage',
  components: {
    NeList,
    DNNProfileTable,
    DNNProfileTableMenu,
    BasicLayout,
  },
  data() {
    return {
      left: {
        show: true,
        name: this.$t("PDN.nelist"),
      },
      middle: {
        show: false,
        name: ''
      },
      right: {
        show: true,
        crumb: this.$t("DNN.crumb"),
      },
      netype: [36],//UDM网元类型
    };
  },
  methods: {
    methodEnum(opcode) {
      switch (opcode) {
        case 'add':
          this.$refs.dnnProfileTable.openAddProfilePage();
          break;
        case 'mod':
          this.$refs.dnnProfileTable.openModProfilePage();
          break;
        case 'del':
          this.$refs.dnnProfileTable.delProfiles();
          break;
        case 'qry':
          this.$refs.dnnProfileTable.qryProfiles(true);
          break;
        default:
      }
    },
    neClick() {
      this.$refs.dnnProfileTable.getGridData(this.$refs.neList.getNe());
    }
  }
};
</script>

<style scoped>

</style>
